import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CandleWorker } from 'client/voladeum/candle-workers/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: CandleWorker[] = EMPTY_ARRAY;

export const candleWorkersSlice = createSlice({
  name: SLICE.CANDLE_WORKERS,
  initialState,
  reducers: {
    setCandleWorkers: (_state, action: PayloadAction<CandleWorker[]>) => {
      return action.payload;
    },
    clearCandleWorkers: () => {
      return initialState;
    },
  },
});

export const { setCandleWorkers, clearCandleWorkers } = candleWorkersSlice.actions;

export default candleWorkersSlice.reducer;
